import React from "react"

var Header=function(){

return <header><h1>Keeper</h1></header>


}

export default Header;